var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoscore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 81,
    height: 60,
    rx: 10.636
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-60.5%",
    y: "-68.3%",
    width: "221%",
    height: "263.3%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.870588235 0 0 0 0 0.88627451 0 0 0 0 0.898039216 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 22)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.996 64.848h57.008M41.996 53.109h57.008M41.996 41.37h57.008",
    stroke: "#EBECEF",
    strokeWidth: 1.182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.069 67.877l6.857-5.416a8.273 8.273 0 0 1 5.128-1.78h1.656c2.074 0 4.073-.78 5.6-2.184l3.47-3.191a8.273 8.273 0 0 1 9.497-1.208l8.454 4.515a8.273 8.273 0 0 0 7.752.023l16.947-8.925",
    stroke: "#4A90E2",
    strokeWidth: 2.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.637 46.252l5.525 3.106a8.273 8.273 0 0 0 9.293-.81L63.07 39.86a8.273 8.273 0 0 1 5.24-1.87h35.035",
    stroke: "#F76B1C",
    strokeWidth: 2.364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoscore);
export default __webpack_public_path__ + "static/media/noscore.1fda1113aa80bce95436e30493009823.svg";
export { ForwardRef as ReactComponent };